var button = 'a33on03';
var interactive = 'a33on02';
var link = 'a33on04';
var main = 'a33on01';
var root = 'a33on00';

export { button, interactive, link, main, root };
//# sourceMappingURL=card-primitive.css.js.map
